import type { Market } from '../types';

export const mockMarkets: Market[] = [
  // ===== 加密货币热门预测 =====
  {
    id: '1',
    title: 'Will Bitcoin reach $200K by end of 2026?',
    description: 'Bitcoin price prediction for year-end 2026. Market resolves YES if BTC/USD trades at or above $200,000 on any major exchange before January 1, 2027.',
    category: 'crypto',
    status: 'active',
    outcomes: [
      { id: '1a', name: 'Yes', probability: 0.58, price: 0.58, volume: 12500000 },
      { id: '1b', name: 'No', probability: 0.42, price: 0.42, volume: 8200000 },
    ],
    totalVolume: 20700000,
    totalLiquidity: 4100000,
    endTime: new Date('2026-12-31'),
    createdAt: new Date('2026-01-01'),
    isTrending: true,
    isFeatured: true,
  },
  {
    id: 'crypto-2',
    title: 'Will Ethereum hit $10,000 before Bitcoin hits $200K?',
    description: 'Which milestone comes first? ETH reaching $10,000 or BTC reaching $200,000.',
    category: 'crypto',
    status: 'active',
    outcomes: [
      { id: 'c2a', name: 'ETH $10K first', probability: 0.35, price: 0.35, volume: 5200000 },
      { id: 'c2b', name: 'BTC $200K first', probability: 0.65, price: 0.65, volume: 9100000 },
    ],
    totalVolume: 14300000,
    totalLiquidity: 2800000,
    endTime: new Date('2026-12-31'),
    createdAt: new Date('2026-01-15'),
    isTrending: true,
    isFeatured: true,
  },
  {
    id: 'crypto-3',
    title: 'Will XRP win the SEC lawsuit by Q3 2026?',
    description: 'Will Ripple finally get regulatory clarity with a final judgment in their favor by end of Q3 2026?',
    category: 'crypto',
    status: 'active',
    outcomes: [
      { id: 'c3a', name: 'Yes', probability: 0.72, price: 0.72, volume: 5800000 },
      { id: 'c3b', name: 'No', probability: 0.28, price: 0.28, volume: 2200000 },
    ],
    totalVolume: 8000000,
    totalLiquidity: 1600000,
    endTime: new Date('2026-09-30'),
    createdAt: new Date('2026-01-10'),
    isTrending: true,
  },
  {
    id: 'crypto-4',
    title: 'Will DOGE reach $1.00 in 2026?',
    description: 'Dogecoin to the moon? Will DOGE trade at or above $1.00 on any major exchange.',
    category: 'crypto',
    status: 'active',
    outcomes: [
      { id: 'c4a', name: 'Yes', probability: 0.38, price: 0.38, volume: 4100000 },
      { id: 'c4b', name: 'No', probability: 0.62, price: 0.62, volume: 6300000 },
    ],
    totalVolume: 10400000,
    totalLiquidity: 2080000,
    endTime: new Date('2026-12-31'),
    createdAt: new Date('2026-01-20'),
    isTrending: true,
  },
  {
    id: 'crypto-5',
    title: 'Will Solana overtake Ethereum in DEX volume by end of 2026?',
    description: 'Solana vs Ethereum: Will Solana have higher monthly DEX volume than Ethereum for 3 consecutive months?',
    category: 'crypto',
    status: 'active',
    outcomes: [
      { id: 'c5a', name: 'Yes', probability: 0.28, price: 0.28, volume: 3200000 },
      { id: 'c5b', name: 'No', probability: 0.72, price: 0.72, volume: 7800000 },
    ],
    totalVolume: 11000000,
    totalLiquidity: 2200000,
    endTime: new Date('2026-12-31'),
    createdAt: new Date('2026-02-10'),
  },
  {
    id: 'crypto-6',
    title: 'Will AI agents manage over $10B in DeFi by end of 2026?',
    description: 'AI-powered DeFi agents. Will autonomous AI agents control over $10B in TVL across DeFi protocols?',
    category: 'crypto',
    status: 'active',
    outcomes: [
      { id: 'c6a', name: 'Yes', probability: 0.45, price: 0.45, volume: 3800000 },
      { id: 'c6b', name: 'No', probability: 0.55, price: 0.55, volume: 4500000 },
    ],
    totalVolume: 8300000,
    totalLiquidity: 1660000,
    endTime: new Date('2026-12-31'),
    createdAt: new Date('2026-02-15'),
    isFeatured: true,
  },
  {
    id: 'crypto-7',
    title: 'Will a Bitcoin Strategic Reserve bill pass in the US by 2026?',
    description: 'Will the US government officially establish Bitcoin as a strategic reserve asset?',
    category: 'crypto',
    status: 'active',
    outcomes: [
      { id: 'c7a', name: 'Yes', probability: 0.42, price: 0.42, volume: 6500000 },
      { id: 'c7b', name: 'No', probability: 0.58, price: 0.58, volume: 8800000 },
    ],
    totalVolume: 15300000,
    totalLiquidity: 3060000,
    endTime: new Date('2026-12-31'),
    createdAt: new Date('2026-01-25'),
    isTrending: true,
  },
  {
    id: 'crypto-8',
    title: 'Will Hyperliquid become a top 5 DEX by TVL in 2026?',
    description: 'The rise of Hyperliquid. Will it join Uniswap, Curve, PancakeSwap in the top 5 DEX rankings?',
    category: 'crypto',
    status: 'active',
    outcomes: [
      { id: 'c8a', name: 'Yes', probability: 0.52, price: 0.52, volume: 2400000 },
      { id: 'c8b', name: 'No', probability: 0.48, price: 0.48, volume: 2200000 },
    ],
    totalVolume: 4600000,
    totalLiquidity: 920000,
    endTime: new Date('2026-12-31'),
    createdAt: new Date('2026-03-12'),
    isTrending: true,
  },
  {
    id: 'crypto-9',
    title: 'Will Monad mainnet launch in Q2 2026?',
    description: 'The most anticipated L1 launch. Will Monad mainnet go live by end of June 2026?',
    category: 'crypto',
    status: 'active',
    outcomes: [
      { id: 'c9a', name: 'Yes', probability: 0.68, price: 0.68, volume: 4200000 },
      { id: 'c9b', name: 'No', probability: 0.32, price: 0.32, volume: 1900000 },
    ],
    totalVolume: 6100000,
    totalLiquidity: 1220000,
    endTime: new Date('2026-06-30'),
    createdAt: new Date('2026-03-08'),
    isTrending: true,
  },
  {
    id: 'crypto-10',
    title: 'Will crypto market cap exceed $10T by end of 2026?',
    description: 'Total crypto market cap prediction. Will we see a $10 trillion market cap?',
    category: 'crypto',
    status: 'active',
    outcomes: [
      { id: 'c10a', name: 'Yes', probability: 0.48, price: 0.48, volume: 8100000 },
      { id: 'c10b', name: 'No', probability: 0.52, price: 0.52, volume: 8600000 },
    ],
    totalVolume: 16700000,
    totalLiquidity: 3340000,
    endTime: new Date('2026-12-31'),
    createdAt: new Date('2026-02-28'),
    isTrending: true,
  },
  {
    id: 'crypto-11',
    title: 'Will US stablecoin legislation pass in 2026?',
    description: 'Will the US Congress pass comprehensive stablecoin regulation this year?',
    category: 'crypto',
    status: 'active',
    outcomes: [
      { id: 'c11a', name: 'Yes', probability: 0.62, price: 0.62, volume: 4900000 },
      { id: 'c11b', name: 'No', probability: 0.38, price: 0.38, volume: 2900000 },
    ],
    totalVolume: 7800000,
    totalLiquidity: 1560000,
    endTime: new Date('2026-12-31'),
    createdAt: new Date('2026-03-01'),
  },
  {
    id: 'crypto-12',
    title: 'Will spot Bitcoin ETF inflows exceed $100B in 2026?',
    description: 'Cumulative inflows into all spot Bitcoin ETFs in 2026. Will it break $100 billion?',
    category: 'crypto',
    status: 'active',
    outcomes: [
      { id: 'c12a', name: 'Yes', probability: 0.55, price: 0.55, volume: 3600000 },
      { id: 'c12b', name: 'No', probability: 0.45, price: 0.45, volume: 2900000 },
    ],
    totalVolume: 6500000,
    totalLiquidity: 1300000,
    endTime: new Date('2026-12-31'),
    createdAt: new Date('2026-02-10'),
    isTrending: true,
  },
  {
    id: 'crypto-13',
    title: 'Will BlackRock launch a crypto ETF beyond BTC/ETH in 2026?',
    description: 'Will BlackRock file for or launch a Solana, XRP, or other crypto ETF?',
    category: 'crypto',
    status: 'active',
    outcomes: [
      { id: 'c13a', name: 'Yes', probability: 0.58, price: 0.58, volume: 4800000 },
      { id: 'c13b', name: 'No', probability: 0.42, price: 0.42, volume: 3400000 },
    ],
    totalVolume: 8200000,
    totalLiquidity: 1640000,
    endTime: new Date('2026-12-31'),
    createdAt: new Date('2026-03-01'),
  },
  {
    id: 'crypto-14',
    title: 'Will a top 10 crypto exchange be hacked for >$500M in 2026?',
    description: 'Major exchange security. Will any top exchange lose over $500M in a hack?',
    category: 'crypto',
    status: 'active',
    outcomes: [
      { id: 'c14a', name: 'Yes', probability: 0.22, price: 0.22, volume: 3200000 },
      { id: 'c14b', name: 'No', probability: 0.78, price: 0.78, volume: 11000000 },
    ],
    totalVolume: 14200000,
    totalLiquidity: 2840000,
    endTime: new Date('2026-12-31'),
    createdAt: new Date('2026-01-15'),
  },
  {
    id: 'crypto-15',
    title: 'Will RWAs (Real World Assets) tokenization exceed $50B by end of 2026?',
    description: 'Tokenized treasuries, real estate, stocks. Will RWA TVL exceed $50 billion?',
    category: 'crypto',
    status: 'active',
    outcomes: [
      { id: 'c15a', name: 'Yes', probability: 0.72, price: 0.72, volume: 5400000 },
      { id: 'c15b', name: 'No', probability: 0.28, price: 0.28, volume: 2100000 },
    ],
    totalVolume: 7500000,
    totalLiquidity: 1500000,
    endTime: new Date('2026-12-31'),
    createdAt: new Date('2026-03-10'),
    isFeatured: true,
  },
  {
    id: 'crypto-16',
    title: 'Will Worldcoin (WLD) be banned in major countries by Q3 2026?',
    description: 'Privacy concerns grow. Will 3+ major countries ban or suspend Worldcoin operations?',
    category: 'crypto',
    status: 'active',
    outcomes: [
      { id: 'c16a', name: 'Yes', probability: 0.35, price: 0.35, volume: 2800000 },
      { id: 'c16b', name: 'No', probability: 0.65, price: 0.65, volume: 5100000 },
    ],
    totalVolume: 7900000,
    totalLiquidity: 1580000,
    endTime: new Date('2026-09-30'),
    createdAt: new Date('2026-02-20'),
  },
  {
    id: 'crypto-17',
    title: 'Will Aave v4 launch in 2026?',
    description: 'Next iteration of DeFi lending. Will Aave release v4 this year?',
    category: 'crypto',
    status: 'active',
    outcomes: [
      { id: 'c17a', name: 'Yes', probability: 0.68, price: 0.68, volume: 3100000 },
      { id: 'c17b', name: 'No', probability: 0.32, price: 0.32, volume: 1400000 },
    ],
    totalVolume: 4500000,
    totalLiquidity: 900000,
    endTime: new Date('2026-12-31'),
    createdAt: new Date('2026-03-15'),
  },
  
  // ===== 其他类别预测 =====
  {
    id: '2',
    title: 'Will Trump complete his full term as President through 2028?',
    description: 'Will Donald Trump serve his complete presidential term from 2025-2029 without removal or resignation?',
    category: 'politics',
    status: 'active',
    outcomes: [
      { id: '2a', name: 'Yes', probability: 0.78, price: 0.78, volume: 8200000 },
      { id: '2b', name: 'No', probability: 0.22, price: 0.22, volume: 2300000 },
    ],
    totalVolume: 10500000,
    totalLiquidity: 2100000,
    endTime: new Date('2028-01-20'),
    createdAt: new Date('2026-01-15'),
    isTrending: true,
  },
  {
    id: '3',
    title: 'Will AGI (Artificial General Intelligence) be achieved by end of 2026?',
    description: 'Will any AI system demonstrate human-level general intelligence across diverse tasks?',
    category: 'ai',
    status: 'active',
    outcomes: [
      { id: '3a', name: 'Yes', probability: 0.18, price: 0.18, volume: 5900000 },
      { id: '3b', name: 'No', probability: 0.82, price: 0.82, volume: 26000000 },
    ],
    totalVolume: 31900000,
    totalLiquidity: 6380000,
    endTime: new Date('2026-12-31'),
    createdAt: new Date('2026-02-01'),
    isTrending: true,
    isFeatured: true,
  },
  {
    id: '4',
    title: 'FIFA World Cup 2026: Will Brazil win?',
    description: 'The 2026 World Cup in North America. Will Brazil lift the trophy?',
    category: 'sports',
    status: 'active',
    outcomes: [
      { id: '4a', name: 'Yes', probability: 0.22, price: 0.22, volume: 3200000 },
      { id: '4b', name: 'No', probability: 0.78, price: 0.78, volume: 11000000 },
    ],
    totalVolume: 14200000,
    totalLiquidity: 2840000,
    endTime: new Date('2026-07-19'),
    createdAt: new Date('2026-01-20'),
    isTrending: true,
  },
  {
    id: '5',
    title: 'Will NASDAQ hit 25,000 by end of 2026?',
    description: 'Stock market prediction. Will NASDAQ Composite Index reach 25,000 points?',
    category: 'finance',
    status: 'active',
    outcomes: [
      { id: '5a', name: 'Yes', probability: 0.48, price: 0.48, volume: 5400000 },
      { id: '5b', name: 'No', probability: 0.52, price: 0.52, volume: 5800000 },
    ],
    totalVolume: 11200000,
    totalLiquidity: 2240000,
    endTime: new Date('2026-12-31'),
    createdAt: new Date('2026-02-10'),
    isFeatured: true,
  },
  {
    id: '6',
    title: 'Will GTA VI be released in 2026?',
    description: 'Grand Theft Auto VI release prediction. Will it finally launch this year?',
    category: 'entertainment',
    status: 'active',
    outcomes: [
      { id: '6a', name: 'Yes', probability: 0.72, price: 0.72, volume: 6500000 },
      { id: '6b', name: 'No', probability: 0.28, price: 0.28, volume: 2500000 },
    ],
    totalVolume: 9000000,
    totalLiquidity: 1800000,
    endTime: new Date('2026-12-31'),
    createdAt: new Date('2026-03-01'),
    isTrending: true,
  },
  {
    id: '7',
    title: 'Will SpaceX Mars mission launch in 2026?',
    description: 'Will SpaceX launch an uncrewed mission to Mars in 2026?',
    category: 'science',
    status: 'active',
    outcomes: [
      { id: '7a', name: 'Yes', probability: 0.35, price: 0.35, volume: 4800000 },
      { id: '7b', name: 'No', probability: 0.65, price: 0.65, volume: 8800000 },
    ],
    totalVolume: 13600000,
    totalLiquidity: 2720000,
    endTime: new Date('2026-12-31'),
    createdAt: new Date('2026-01-25'),
  },
  {
    id: '8',
    title: 'Will TikTok be sold to a US company by end of 2026?',
    description: 'Will ByteDance sell TikTok to an American company to avoid ban?',
    category: 'social',
    status: 'active',
    outcomes: [
      { id: '8a', name: 'Yes', probability: 0.55, price: 0.55, volume: 5100000 },
      { id: '8b', name: 'No', probability: 0.45, price: 0.45, volume: 4100000 },
    ],
    totalVolume: 9200000,
    totalLiquidity: 1840000,
    endTime: new Date('2026-12-31'),
    createdAt: new Date('2026-02-15'),
  },
];
